import { render, staticRenderFns } from "./IconExport.vue?vue&type=template&id=4130c701&"
import script from "./IconExport.vue?vue&type=script&lang=ts&"
export * from "./IconExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports